export default __webpack_public_path__ + "static/media/view-larger.2940eb74.svg";